import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { CourseFormValues } from "src/models/Course.model";
import Course from "../Layouts/CourseForm";
import {
  useGetCourseByIdQuery,
  useUpdateCourseByIdMutation,
} from "src/services/CourseService";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import { capitalizeFirstLetter } from "src/utils/helper/stringHelper";

type Props = {
  onClose: () => void;
  selectedCourseId: string;
};

const EditCourseWrapper = ({ onClose, selectedCourseId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } =
    useGetCourseByIdQuery(selectedCourseId);
  const [updateFacultyById] = useUpdateCourseByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: CourseFormValues = {
    courseName: items?.courseName || "",
    courseCode: items?.courseCode || "",
    orderRank: items?.orderRank || "",
    type: {
      label: capitalizeFirstLetter(items?.type),
      value: items?.type,
    },
    levels: items?.levels?.map((l: any) => ({
      label: l.levelName,
      value: l.levelId,
    })),
  };

  // Validation Schema
  const validationSchema = object().shape({
    courseName: string().required("Please enter course name"),
    courseCode: string().required("Please enter course code"),
    // orderRank: string().required("Please enter order rank"),
    type: object().required("Please select type"),
  });

  // Handle Submit
  const handleSubmit = (
    values: CourseFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CourseFormValues>
  ) => {
    const payload = {
      courseName: values.courseName,
      courseCode: values.courseCode,
      orderRank: Number(values.orderRank),
      type: values.type.value,
      levels: values.levels?.map((l: any) => l.value),
    };
    updateFacultyById({ id: selectedCourseId, body: payload }).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };
  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Course
              formikProps={formikProps}
              onClose={onClose}
              formType="EDIT"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditCourseWrapper;
